const initialState = [];
export const watchLiveChannelActual = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_WATCH_LIVE_CHANNELS_ACTUAL':
          return action.payload;
      default:
        return state;
    }
  }